module.exports = __webpack_public_path__ + "img/front.ac283e50.png";